import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { sessionStore, storedRefreshToken } from '@/core/auth/session.store.js';
import { toast } from '@/shared/ui/index.js';

import { logout } from '../infrastructure/auth.api.js';

/**
 * Cierre de sesión.
 *
 * Limpia siempre el estado local aunque el servidor falle: dejar la sesión
 * viva en el navegador porque el revoke no respondió sería lo peor de ambos
 * mundos. También vacía la caché para que ningún dato del usuario anterior
 * quede visible.
 */
export function useLogout() {
  const clear = sessionStore((state) => state.clear);
  const queryClient = useQueryClient();

  return useCallback(async () => {
    const token = storedRefreshToken();
    try {
      if (token !== undefined) {
        await logout(token);
      }
    } finally {
      clear();
      queryClient.clear();
      toast.info('Sesión cerrada');
    }
  }, [clear, queryClient]);
}
